export const STATUS = {
  // Completed states
  COMPLETE: 'complete',
  PASSED: 'passed',
  APPROVED: 'approved',

  // In-progress states
  IN_PROGRESS: 'in_progress',
  QUALIFIED: 'qualified',
  INCOMPLETE: 'incomplete',
  PENDING: 'pending',
  REGISTERED: 'registered',
  ATTENDING: 'attending',
  SUBMITTED: 'submitted',
  IN_REVIEW: 'in_review',
  RETURNED: 'returned',
  DEFERRED: 'deferred',

  // Locked/Failed states
  LOCKED: 'locked',
  DENIED: 'denied',
  FAILED: 'failed',

  // Other states
  EXPIRED: 'expired',
  READY: 'ready',
  NOT_STARTED: 'not_started',
}

export const STATUS_CATEGORIES = {
  COMPLETE: [
    STATUS.COMPLETE,
    STATUS.PASSED,
    STATUS.APPROVED,
  ],

  IN_PROGRESS: [
    STATUS.IN_PROGRESS,
    STATUS.QUALIFIED,
    STATUS.INCOMPLETE,
    STATUS.PENDING,
    STATUS.REGISTERED,
    STATUS.ATTENDING,
    STATUS.SUBMITTED,
    STATUS.IN_REVIEW,
    STATUS.RETURNED,
    STATUS.DEFERRED,
  ],

  LOCKED: [STATUS.LOCKED, STATUS.DENIED, STATUS.FAILED],

  READY: [STATUS.READY, STATUS.EXPIRED, STATUS.NOT_STARTED],
}

// Priority order for aggregating multiple statuses
// Higher index = higher priority
export const STATUS_PRIORITY = [
  STATUS.LOCKED,
  STATUS.DENIED,
  STATUS.FAILED,
  STATUS.NOT_STARTED,
  STATUS.READY,
  STATUS.EXPIRED,
  STATUS.DEFERRED,
  STATUS.RETURNED,
  STATUS.INCOMPLETE,
  STATUS.IN_PROGRESS,
  STATUS.PENDING,
  STATUS.SUBMITTED,
  STATUS.IN_REVIEW,
  STATUS.REGISTERED,
  STATUS.ATTENDING,
  STATUS.QUALIFIED,
  STATUS.PASSED,
  STATUS.APPROVED,
  STATUS.COMPLETE,
]
